import type {
  SettingsDTO,
  SettingsUpdateInput,
} from "@/modules/settings/domain/contracts";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export const settingsApi = {
  async getPrintContact(): Promise<{ phone: string }> {
    return fetcher.get<{ phone: string }>(
      `${config.apiUrl}/settings/print-contact`,
    );
  },

  async get(): Promise<SettingsDTO> {
    return fetcher.get<SettingsDTO>(`${config.apiUrl}/settings`);
  },
  async update(input: SettingsUpdateInput): Promise<SettingsDTO> {
    return fetcher.put<SettingsDTO>(`${config.apiUrl}/settings`, input);
  },
};
